// Import just what we need
// import 'bootstrap/js/dist/alert';
// import 'bootstrap/js/dist/button';
// import 'bootstrap/js/dist/carousel';
// import 'bootstrap/js/dist/collapse';
// import 'bootstrap/js/dist/dropdown';
// import 'bootstrap/js/dist/modal';
// import 'bootstrap/js/dist/popover';
// import 'bootstrap/js/dist/scrollspy';
// import 'bootstrap/js/dist/tab';
// import 'bootstrap/js/dist/toast';
// import 'bootstrap/js/dist/tooltip';

//Import all of bootstrap js files
const bootstrap = require("bootstrap");

//Esto importa bootstrap desde styles.scss
import "../sass/styles.scss";

//Importing images on metatags to be processed
//Replace with appropiate
// import "../img/social/cancun-airport.jpg";
// import "../img/social/cancun-airport-car-rental.jpg";
